export default class TiposDeCanaisEnum {
  static Email = 1
  static Autoatendimento = 2
  static AberturaManual = 3
  static WhatsApp = 4
  static Bot = 5
  static MetaMessenger = 6
  static SMS = 7
}
